module.exports = __webpack_public_path__ + "static/media/security-safes.e5546db2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/hero/security-safes.jpg
// module id = 1245
// module chunks = 0